/**
 * Shared vocabulary for the DATEV-settings change history (PRD #1319 / RS-002).
 *
 * A history row records *which* foldout was saved, *who* saved it, and the
 * before/after of only the fields that actually changed. `reason` and
 * `carryOverCount` are recorded nullable now — the freeze that makes a reason
 * mandatory (RS-003) and the mode-switch carry-over count (RS-004) land later.
 */
/**
 * The DATEV-settings change origins, used to label a history row. The first
 * three mirror the editable foldouts; `MODE_SWITCH` is the guarded
 * Gewinnermittlungsart migration (PRD #1319 / RS-004), which is no longer an
 * ordinary Kontenrahmen-&-Steuerart edit but a ledger carry-over operation.
 */
export var DatevSettingsFoldout;
(function (DatevSettingsFoldout) {
    DatevSettingsFoldout["SCHNITTSTELLE"] = "schnittstelle";
    DatevSettingsFoldout["KONTENRAHMEN_STEUERART"] = "kontenrahmen-steuerart";
    DatevSettingsFoldout["KONTEN_MAPPING"] = "konten-mapping";
    DatevSettingsFoldout["MODE_SWITCH"] = "mode-switch";
})(DatevSettingsFoldout || (DatevSettingsFoldout = {}));
/**
 * Who made the change. `USER` is a logged-in clinic user; the actor's
 * `userId` is their id. `STEUERBERATER_TOKEN` is a Steuerberater share-link
 * write; the actor carries the token id *and* the id of the ADMIN who issued
 * the token (as `userId`), so a token change is attributable to a person.
 */
export var DatevSettingsActorType;
(function (DatevSettingsActorType) {
    DatevSettingsActorType["USER"] = "USER";
    DatevSettingsActorType["STEUERBERATER_TOKEN"] = "STEUERBERATER_TOKEN";
})(DatevSettingsActorType || (DatevSettingsActorType = {}));
//# sourceMappingURL=datev-settings-history.js.map